import * as Icons from 'lucide-react';
import { ArrowUpRight, Minus } from 'lucide-react';
import { MARKET_COVERAGE } from '../../config/site';
import { SectionHeader } from '../common';

export default function MarketCoverage() {
  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="reveal"><SectionHeader eyebrow="Market Coverage" title="Every market that matters." sub="Analyze and act across four core asset classes from a single, unified command surface." /></div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
          {MARKET_COVERAGE.map((m, i) => {
            const Icon = Icons[m.icon] || Icons.CircleDollarSign;
            return (
              <div key={m.title} className="panel panel-hover p-6 reveal" style={{ transitionDelay: `${i * 60}ms` }}>
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: 'var(--gold-soft)', border: '1px solid var(--gold-border)' }}><Icon size={22} className="text-[var(--gold-2)]" /></div>
                  <span className="flex items-center gap-1 font-mono text-[11px]" style={{ color: m.tone === 'up' ? 'var(--emerald)' : 'var(--muted)' }}>{m.tone === 'up' ? <ArrowUpRight size={13} /> : <Minus size={13} />}Live</span>
                </div>
                <h3 className="font-display text-[19px] font-bold text-white">{m.title}</h3>
                <p className="mt-1.5 text-[13.5px] text-[var(--muted)]">{m.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
